module.exports = __webpack_public_path__ + "img/Information flow_Outline.c380a8b5.png";